'use client';

import { type RefObject, useEffect } from 'react';

/*
TO DO: this fixes the focus trapping issue on dialogs for now.
in future, let's decide if we should refactor this within useFocusScope, delete useFocusScope, or use radix-ui's internal focus trapping
*/
export function useFocusTrap(modalRef: RefObject<HTMLDivElement | null>) {
  useEffect(() => {
    const modal = modalRef.current;
    if (modal) {
      const focusableElements = modal.querySelectorAll(
        'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
      ) as NodeListOf<HTMLElement>;
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement =
        focusableElements[focusableElements.length - 1];

      const handleTab = (e: KeyboardEvent) => {
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) return;

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement?.focus();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement?.focus();
          }
        }
      };

      modal.addEventListener('keydown', handleTab);

      firstFocusableElement?.focus(); // Set focus to the first focusable element

      return () => {
        modal.removeEventListener('keydown', handleTab);
      };
    }
  }, [modalRef]);
}
